import React from 'react';
import ReactDOM from 'react-dom';
import { ThemeProvider, Theme, StyledEngineProvider } from '@mui/material/styles';
import { GlobalTheme } from '~/_base/apeMuiTheme';
import { SWRConfig } from 'swr';
import { ToastProvider } from '~/_base/context/toastContext';
import App from './app';
import './errorLogging';
declare module '@mui/styles/defaultTheme' {
  // eslint-disable-next-line @typescript-eslint/no-empty-interface
  interface DefaultTheme extends Theme {}
}

require('~/_base/styles/_apeMuiTheme.scss');

document.addEventListener('DOMContentLoaded', function() {
  const form = document.getElementById('react-trial-setup');
  ReactDOM.render(
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={GlobalTheme}>
        <ToastProvider>
          <SWRConfig
            value={{
              revalidateOnFocus: false,
            }}
          >
            <App />
          </SWRConfig>
        </ToastProvider>
      </ThemeProvider>
    </StyledEngineProvider>,
    form
  );
});
